/* eslint-disable max-len */
/* eslint-disable no-invalid-this */
/* eslint-disable comma-dangle */
// imports
import utils from './utils';
import _ from 'lodash';

// A function to handle the switch between
// mobile and desktop images on load and on resize

export function initFocalPoint() {
    let focalPointObjects = $(document).find('[data-focalimage]');

    // handle focalpoint images once on page load
    handleFocalPoints(focalPointObjects);

    // handle focalpoint images on resize (with a debounce to avoid costly operations)
    $(window).on('resize', _.debounce(function() {
        handleFocalPoints(focalPointObjects);
    }, 150));
}

function handleFocalPoints(focalPointObjects) {
    focalPointObjects.each(function() {
        // get the object type (Image or anything else)
        let $this = $(this);
        let isImage = $this.is('img'); // true / false
        // get the focalimage data object
        let data = $this.data('focalimage');
        // check if the object has both desktop and mobile images
        // if not, use the same image for both
        if (data.desktop && (!data.mobile || data.mobile == '')) {
            data['mobile'] = data.desktop;
        }

        // check if they are not empty strings as well
        if (
            data.desktop &&
            data.desktop != '' &&
            data.mobile &&
            data.mobile != ''
        ) {
            let imageToUse = utils.isBelowMd() ? data.mobile : data.desktop;

            if (isImage) {
                $this.attr('src', imageToUse);
            } else {
                $this.css({
                    'background-image': `url('${imageToUse}')`
                });

                // handle has-mbImage cases
                if (utils.isBelowMd()) {
                    $this.removeClass('has-mbImage');
                } else {
                    $this.addClass('has-mbImage');
                }
            }
        }
    });
}
